import React from 'react'
import ContextProvider from './src/context/Context'
import { trackAIReferral } from './src/lib/ai-tracking'

export const wrapRootElement = ({ element }) => {
  return <ContextProvider>{element}</ContextProvider>
}

export const onRouteUpdate = () => {
  trackAIReferral()
}
